<template>
  <div>
    <el-main>

    <el-table id="dataTable" :data="dataList" :border="border" :height="tableHeight"
              style="height:auto;" :header-cell-style="tableHeaderColor">
<!--      <el-table-column header-align="center" align="center"  prop="questionId" label="编号" width="" ></el-table-column>-->
      <el-table-column header-align="center" label="问题" width="1180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;margin-left: 10px" v-html="scope.row.question "></div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" label="状态" width="200" show-overflow-tooltip>
        <template slot-scope="scope">
            <div v-if="scope.row.dealStatus ==='0'" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">待处理</div>
            <div v-else-if="scope.row.dealStatus ==='1'" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">已添加到问答库</div>
            <div v-else style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">忽略</div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="操作" width="200" >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" style="color: #FFFFFF"  @click="changeQaInfo(scope.row)">添加</el-button>
          <el-button size="mini" class="grey"  @click="open(scope.row)">忽略</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top:40px;right:10px; width:100%; text-align:right;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalPageNum">
      </el-pagination>
    </div>
      <!-- 修改信息弹窗-->
      <el-dialog title="问答添加" :visible.sync="changedialogFormVisible">
        <el-form :model="changeinfoform">
          <el-form-item label="问题" :label-width="formLabelWidth">
            <el-input   v-model="changeinfoform.c_question"  autocomplete="off" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="答案" :label-width="formLabelWidth">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="changeinfoform.c_answer">
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="changedialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="changeDialog()" :loading="isLoading">确 定</el-button>
        </div>
      </el-dialog>

    </el-main>
  </div>
</template>

<script>
// import $ from 'jquery'
import { getQAList, updateQA, post} from '@/api/common'
export default {
  name: 'personsend',
  data () {
    return {
      fileList: [],
      currentPage: 1,
      totalPageNum: 0,
      dataList: [],
      tableHeight: '200px',
      border: false,
      colShow: false,
      isLoading: false,
      total: 0,
      changedialogFormVisible: false,
      pageSize: 10,
      pageNow: 0,
      changeinfoform: {
        c_question: '',
        c_answer: ''

      },
      timer: '',
      formLabelWidth: '120px',
      innerVisible: false,
      value: '',
      id: '',
      userId: '15678902834',
      selectrow: ''
    }
  },
  created () {
    this.userId = localStorage.getItem('userId')
    this.tableHeight = window.innerHeight - 352 + 'px'
    window.onresize = () => {
      return (() => {
        this.tableHeight = window.innerHeight - 352 + 'px'
      })()
    }
  },
  mounted: function () {
    let params = {
      pageSize: this.pageSize,
      pageNow: this.pageNow
    }
    this.queryStr(params)
    this.dialogVisible = false
  },
  methods: {
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },
    changeQaInfo (row) {
      console.log('选中的:::' + JSON.stringify(row))
      this.changedialogFormVisible = true
      this.selectrow = row
      this.changeinfoform.c_question = row.question
      this.changeinfoform.c_answer = row.answer
    },
    changeDialog () {
      if (this.changeinfoform.c_answer === '' || this.changeinfoform.c_answer === null) {
        this.$notify({
          title: '提示',
          message: '答案不能为空',
          type: 'warning'
        })
        return
      }
      this.updateQA()
    },
    updateQA () {
      this.isLoading = true
      let url = '/addUnknownQAToRealQa'
      let params = {
        id: this.selectrow.id,
        questionId: this.selectrow.questionId,
        createTime: this.selectrow.createTime,
        question: this.changeinfoform.c_question,
        answer: this.changeinfoform.c_answer,
        dealStatus: '1'
      }
      updateQA(url, params).then(response => {
        if (response.data.code === 0) {
          this.isLoading = false
          this.changedialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '添加成功',
            type: 'success'
          })
          let params = {
            pageSize: this.pageSize,
            pageNow: this.pageNow
          }
          clearTimeout(this.timer)
          this.timer = setTimeout(() => { // 设置延迟执行
            this.getQAList(params)
          }, 1000)
        } else {
          this.isLoading = false
          this.$notify({
            title: '提示',
            message: '系统异常',
            type: 'warning'
          })
        }
      }).catch(response => {
        this.isLoading = false
        this.$notify({
          title: '提示',
          message: '添加失败，请重试',
          type: 'warning'
        })
      })
    },
    /* 点击切换先去修改分配状态
    * status 1 是自动分配
    * status 0是全员分配 */
    tableHeaderColor ({ row, column, rowIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #f0f0f0;'
      }
    },
    selectTrigger (val) {
    },
    open (row) {
      this.$confirm('此操作将忽略该问题, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delQA(row)
      }).catch(() => {
        this.$notify({
          title: '提示',
          message: '已取消该操作',
          type: 'warning'
        })
      })
    },
    // 删除问答
    delQA (row) {
      console.log('删除：' + row.id)
      let url = '/ignoreUnknownQA'
      let params = {
        id: row.id,
        questionId: row.questionId
      }
      post(url, params).then(response => {
        // console.log('删除几口' + JSON.stringify(response))
        if (response.data.code === 0) {
          this.$notify({
            title: '成功',
            message: '忽略成功',
            type: 'success'
          })
          let params = {
            pageSize: this.pageSize,
            pageNow: this.pageNow
          }
          clearTimeout(this.timer)
          this.timer = setTimeout(() => { // 设置延迟执行
            this.getQAList(params)
          }, 1000)
        }
      }).catch(response => {
        this.$notify({
          title: '提示',
          message: '操作失败，请重试',
          type: 'warning'
        })
      })
    },
    queryStr (evt) {
      let target = evt.target
      if (target) {
        // 根据button组件内容 里面包括一个span标签，如果设置icon，则还包括一个i标签，其他情况请自行观察。
        // 所以，在我们点击到button组件上的文字也就是span标签上时，直接执行e.target.blur()不会生效，所以要加一层判断。
        if (target.nodeName) {
          if (target.nodeName === 'SPAN' || target.nodeName === 'I') {
            target = evt.target.parentNode
          }
        }
        target.blur()
      }

      this.pageNow = 0
      this.currentPage = 1
      let params = {
        pageSize: this.pageSize,
        pageNow: this.pageNow
      }
      this.getQAList(params)
    },
    // 获取问答列表
    getQAList: function (params) {
      let url = '/getUnknowQaList'
      getQAList(url, params).then(response => {
        // console.log('获取人员列表' + JSON.stringify(response))
        if (response.data.ret === 1) {
          this.dataList = response.data.content.qaList
          console.info(response.data.content.qaList)
          this.totalPageNum = response.data.content.elementsCount
        }
      }).catch(response => {
        this.totalPageNum = 0
        this.$notify({
          title: '提示',
          message: '获取问答列表失败，请刷新重试',
          type: 'warning'
        })
      })
    },
    handleSizeChange (pageSize) {
      console.log('handleSizeChange')
      this.pageSize = pageSize
      this.dataList = []
      let params = {
        pageSize: this.pageSize,
        pageNow: this.pageNow
      }
      this.getQAList(params)
      console.log(`每页 ${pageSize} 条`)
    },
    handleCurrentChange (currentPage) {
      console.info('handleCurrentChange')
      this.pageNow = currentPage - 1
      this.dataList = []
      let params = {
        pageSize: this.pageSize,
        pageNow: this.pageNow
      }

      this.getQAList(params)
      console.log(`当前页: ${currentPage - 1}`)
    },
    showExceptionMessage: function () {
      this.$notify({
        title: '提示',
        message: '系统异常：请联系管理员！',
        type: 'error'
      })
    }

  }
}
</script>
<style scoped>
  .activecolor{
    background-color: #67c23a !important;
    color: #fff;
    width: 67px;
    text-align: center;
  }
  .grey{
    background-color: gainsboro;
    width: 67px;
    text-align: center;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/views/services/unknowQa.vue